import { Pagination } from "@/types/static.types";

export const turnPageHandler = (
  currentPage: Pagination<any>,
  nextPage: Pagination<any>
): Pagination<any> => {
  const { atPage } = nextPage;
  if (atPage === 1) {
    return nextPage;
  } else {
    return { ...nextPage, items: [...currentPage.items, nextPage.items] };
  }
};

export const phoneNumberHandler = (phone: string) => {
  let res = phone;
  if (phone.length === 10 || phone[0] === "0") {
    res = phone.slice(1);
  }

  return res;
};
